import * as React from 'react';
import { Box, Typography } from '@mui/material';

import { CloseButton, Dialog, DialogActions, DialogContent, DialogTitle, SubmitButton } from 'components';
import { ShippingAddressForm } from 'forms';

interface ShippingAddressDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
}

export const ShippingAddressDialog = ({ visible = false, setVisible = () => {} }: ShippingAddressDialogProps) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const formRef = React.useRef<any>();

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  return (
    <Dialog onClose={onClose} open={visible}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          Update Shipping Address
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ paddingY: 5 }}>
          <ShippingAddressForm
            ref={formRef}
            onLoading={(loading) => setLoading(loading)}
            next={() => setVisible(false)}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <SubmitButton loading={loading} label={'Update'} onClick={() => formRef.current.onSubmit()} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
